import { Notify as QuasarNotify } from 'quasar';

export function createNotification({ commit }, payload) {
  const error = payload.error;
  const requestUrl = error && error.config && error.config.url ? error.config.url : undefined;
  if (requestUrl !== undefined) commit('addNotificationRequestUrl', requestUrl);
  QuasarNotify.create(payload.notification);
}

export function clearNotificationRequestUrl({ commit }, payload) {
  commit('clearNotificationRequestUrl', payload);
}
